import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import '../../styles/commonModal.css';

const root = document.getElementById('root');
const DEBUG_MODAL = true; // set false when done debugging

class CommonModal extends Component {
    constructor(props) {
        super(props);

        this.modalOverlay = document.createElement('div');
        let body = document.getElementsByTagName("BODY")[0];
        body.style.overflow = 'hidden';

        this.closeModal = this.closeModal.bind(this);
        this.captureClickForFreeProduct = this.captureClickForFreeProduct.bind(this);
    }

    // Run in capture phase: if user just closed free-product modal via X, stop the synthetic click so closeModal never runs (avoids re-open)
    captureClickForFreeProduct(e) {
        if ((this.props.className || '').includes('freeProduct') &&
            typeof window !== 'undefined' && window.__freeProductClosedByButtonAt &&
            (Date.now() - window.__freeProductClosedByButtonAt) < 1000) {
            e.stopPropagation();
            e.preventDefault();
        }
    }

    componentDidMount() {
        const overlayClass = ['commonModal', this.props.overlayClassName].filter(Boolean).join(' ');
        root.appendChild(this.modalOverlay);
        this.modalOverlay.setAttribute('class', overlayClass);
        this.modalOverlay.addEventListener('click', (e) => this.closeModal(e), false);
        if ((this.props.className || '').includes('freeProduct')) {
            this.modalOverlay.addEventListener('click', this.captureClickForFreeProduct, true);
        }
    }

    componentWillUnmount() {
        root.removeChild(this.modalOverlay);
        this.modalOverlay.removeEventListener('click', (e) => this.closeModal(e), false);
        if ((this.props.className || '').includes('freeProduct')) {
            this.modalOverlay.removeEventListener('click', this.captureClickForFreeProduct, true);
        }
        // Dont allow scrolling befora cart modal close
        if (!this.props.isCartModalOpen) {
            let body = document.getElementsByTagName("BODY")[0];
            body.style.overflowY = 'auto';
        }
    }

    closeModal(e) {
        const now = Date.now();
        const contentElByClass = this.props.className ? document.getElementsByClassName(this.props.className)[0] : null;
        const contentElFromOverlay = this.modalOverlay && this.modalOverlay.firstElementChild;
        const contentEl = contentElByClass;
        const inside = contentEl && contentEl.contains(e.target);
        const closedAt = typeof window !== 'undefined' ? window.__freeProductClosedByButtonAt : null;
        const justClosedByButton = closedAt != null &&
            (now - closedAt) < 600 &&
            (this.props.className || '').includes('freeProduct');
        const willToggle = !inside && !justClosedByButton;

        if (DEBUG_MODAL && (this.props.className || '').includes('freeProduct')) {
            const targetInsideByClass = contentElByClass ? contentElByClass.contains(e.target) : null;
            const targetInsideFromOverlay = contentElFromOverlay ? contentElFromOverlay.contains(e.target) : null;
            const sameElement = contentElByClass === contentElFromOverlay;
            const logPayload = {
                eventType: e?.type,
                targetId: e?.target?.id,
                targetClass: e?.target?.className,
                contentElByClass: contentElByClass ? { id: contentElByClass.id, className: contentElByClass.className, tagName: contentElByClass.tagName } : null,
                contentElFromOverlay: contentElFromOverlay ? { id: contentElFromOverlay.id, className: contentElFromOverlay.className, tagName: contentElFromOverlay.tagName } : null,
                sameElement,
                targetInsideByClass,
                targetInsideFromOverlay,
                inside,
                closedAt,
                age: closedAt != null ? now - closedAt : null,
                justClosedByButton,
                willToggle
            };
            console.log('[CommonModal freeProduct] click', logPayload);
            if (typeof window !== 'undefined') window.__lastCommonModalFreeProductClick = logPayload;
        }

        if (willToggle) {
            this.props.toggle();
        }
    }

    renderDialog() {
        if (this.props.isOpen) {
            return (
                <div
                    className={`modalDialog ${this.props.dialogName}`}
                    // style={{ height: this.state.operationSystem.includes('Safari') ? window.outerHeight : 'auto'}}
                >{this.props.children}</div>
            );
        }
    }

    render() {
        return ReactDOM.createPortal(
            this.renderDialog(),
            this.modalOverlay,
        );
    }
}

export default CommonModal;